(function () {
	const slideUp = (element) => {
		if (!element) return;
		element.style.display = "none";
	};

	const slideDown = (element) => {
		if (!element) return;
		element.style.display = "block";
	};

	const fadeOut = (element) => {
		if (!element) return;
		element.style.display = "none";
	};

	const fadeIn = (element) => {
		if (!element) return;
		element.style.display = "block";
	};

	const initCollapsibleContent = () => {
		document.querySelectorAll(".collapsible-content__toggle").forEach((toggle) => {
			if (toggle.dataset.collapsibleBound === "true") return;
			toggle.dataset.collapsibleBound = "true";

			toggle.addEventListener("click", function () {
				const parent = this.parentElement;
				const answer = this.nextElementSibling;
				if (!parent || !answer) return;

				if (!parent.classList.contains("active")) {
					parent.parentElement
						?.querySelectorAll(".collapsible-content__item.active")
						.forEach((item) => item.classList.remove("active"));
					parent.classList.add("active");
					this.closest(".collapsible-content__items")
						?.querySelectorAll(".collapsible-content__answer")
						.forEach((el) => slideUp(el));
					slideDown(answer);
				} else {
					parent.classList.remove("active");
					slideUp(answer);
				}
			});
		});
	};

	const startCollapsibleSlideshow = (images) => {
		if(images.length > 1) {
			const gallery = images[0].closest('.collapsible-content__gallery');
			const speed = Number(gallery?.dataset.speed || 3) * 1000;
			let currentImageIndex = 0;

			fadeIn(images[currentImageIndex]);

			setInterval(function () {
				const nextImageIndex = (currentImageIndex + 1) % images.length;
				fadeOut(images[currentImageIndex]);
				fadeIn(images[nextImageIndex]);
				currentImageIndex = nextImageIndex;
			}, speed);
		}
	}

	const initGallery = () => {
		const blocks = document.querySelectorAll('.collapsible-content');
		if(blocks.length > 0) {
			blocks.forEach(function(item) {
				const images = Array.from(
					item.querySelectorAll(".collapsible-content__gallery--image-wrapper")
				);

				if (item.querySelectorAll(".observe-me").length > 0) {
					function createObserver() {
							function handleIntersect(entries, observer) {
									entries.forEach(entry => {
											if (entry.isIntersecting) {
													let css_classlist = entry.target.classList;
													css_classlist.add("is-inview");

													observer.unobserve(entry.target);

													setTimeout(() => {
															css_classlist.remove("is-inview");
															css_classlist.remove("observe-me");

															startCollapsibleSlideshow(images);
													}, 600); // Duration matches the animation duration in SCSS
											}
									});
							}

							let options = {
									root: null,
									rootMargin: "0px",
									threshold: 0.1
							};

							let observer = new IntersectionObserver(handleIntersect, options);
							let targets = item.querySelectorAll(".observe-me");
							targets.forEach((target, index) => {
									observer.observe(target);
							});
					}

					createObserver();
			} else {
					// If there are no elements to observe, start the gallery slideshow immediately
					startCollapsibleSlideshow(images);
			}
			});
		}
	};

	initCollapsibleContent();
	initGallery();

	document.addEventListener("DOMContentLoaded", function () {
		initCollapsibleContent();
		initGallery();
		document.addEventListener("shopify:section:load", function () {
			initCollapsibleContent();
			initGallery();
		});
	});
})();
